import React, { useState } from "react";

export default function AllowedServices() {
  // State for the selected options
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState([]);
  const [allowedAPI, setAllowedAPI] = useState(false);
  const [liveTransactionsAllowed, setLiveTransactionsAllowed] = useState(false);

  const paymentMethods = ["MasterCard", "Visa", "Verve"];

  const handlePaymentMethodChange = (method) => {
    if (selectedPaymentMethods.includes(method)) {
      setSelectedPaymentMethods(
        selectedPaymentMethods.filter((m) => m !== method)
      );
    } else {
      setSelectedPaymentMethods([...selectedPaymentMethods, method]);
    }
  };

  return (
    <div className="gateway-settings-tab">
      <div className="allowed-services-container">
        {/* Payment Methods Card */}
        <div className="card">
          <h5>Select Allowed Payment Methods</h5>
          <div className="payment-options">
            {paymentMethods.map((method) => (
              <div key={method} className="payment-method">
                <input
                  type="checkbox"
                  id={method}
                  checked={selectedPaymentMethods.includes(method)}
                  onChange={() => handlePaymentMethodChange(method)}
                />
                <label htmlFor={method}>{method}</label>
              </div>
            ))}
          </div>
        </div>

        {/* Allowed API Card */}
        <div className="card">
          <h5>Allowed API Access</h5>
          <div className="api-options">
            <label className="switch">
              <input
                type="checkbox"
                checked={allowedAPI}
                onChange={() => setAllowedAPI(!allowedAPI)}
              />
              <span className="slider round"></span>
            </label>
            <p>{allowedAPI ? "API Access Enabled" : "API Access Disabled"}</p>
          </div>
        </div>

        {/* Live Transactions Card */}
        <div className="card">
          <h5>Live Transactions Allowed</h5>
          <div className="live-options">
            <label className="switch">
              <input
                type="checkbox"
                checked={liveTransactionsAllowed}
                onChange={() =>
                  setLiveTransactionsAllowed(!liveTransactionsAllowed)
                }
              />
              <span className="slider round"></span>
            </label>
            <p>
              {liveTransactionsAllowed
                ? "Live Transactions Enabled"
                : "Live Transactions Disabled"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
